export function isMac(): boolean {
  return navigator.userAgent.indexOf("Macintosh") !== -1;
}
